"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectOutline = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "type", "name", "form", "label", "placeholder", "options", "value", "onChange", "onBlur", "disabled", "errorMessage", "optional", "helper"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var IconArrowDown = function IconArrowDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13 6-5 5-5-5",
    stroke: "#262F56",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
IconArrowDown.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledSelectOutline = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-l9ez6c-0"
})(["position:relative;.selected{", " border-radius:8px;box-sizing:border-box;padding:14px;", " cursor:pointer;&.placeholder{", "}.show{transform:rotateX(180deg);}&.disabled{cursor:default;", " ", " svg path{", "}}}.options-group{position:absolute;z-index:1;display:none;transform:translate(0,", ");transform:translate(0,var(--k-ds-spacing-01));overflow-y:auto;width:100%;max-height:186px;", " ", " border-radius:8px;box-sizing:border-box;", " &.show{display:block;}}.option{input[type=\"radio\"]{display:none;}label{display:block;padding:14px;cursor:pointer;:hover{", " ", "}}}.helper-error{position:absolute;top:3.5rem;left:0;right:0;", " ", "}"], _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'interactive-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-secondary'), _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'background-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-placeholder'), _kDsFoundation["default"].setColorTokenWithFallback('fill: ', 'background-alternate'), _kDsFoundation["default"].getSpacing('spacing-01'), _kDsFoundation["default"].setColorWithFallback('background: ', 'white'), _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'interactive-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'), _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'background-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-primary'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-placeholder'), function (props) {
  return props.hasError && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'error'));
});
var SelectOutline = exports.SelectOutline = function SelectOutline(_ref) {
  var className = _ref.className,
    children = _ref.children,
    type = _ref.type,
    name = _ref.name,
    form = _ref.form,
    label = _ref.label,
    placeholder = _ref.placeholder,
    options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    optional = _ref.optional,
    helper = _ref.helper,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var hasError = Boolean(errorMessage);
  var required = moreProps.required;
  var props = _objectSpread(_objectSpread({}, moreProps), {}, {
    hasError: hasError
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isFirstRender = _useState4[0],
    setIsFirstRender = _useState4[1];
  (0, _react.useEffect)(function () {
    if (isFirstRender) {
      setIsFirstRender(false);
    }
  }, []);
  var valueText = '';
  var selectOptions = options || [];
  var optionsData = selectOptions.map(function (option) {
    var id = option.text.toLowerCase().replace(/ /g, '_');
    id = "".concat(name || '', "_").concat(id);
    var isSelected = option.value === value;
    if (isSelected) {
      valueText = option.text;
    }
    return {
      id: id,
      text: option.text,
      value: option.value,
      isSelected: isSelected
    };
  });
  var onSelectClick = function onSelectClick() {
    if (disabled) return;
    setIsActive(!isActive);
  };
  var onOptionClick = function onOptionClick(optionValue) {
    if (onChange) onChange(optionValue);
    setIsActive(false);
  };
  (0, _react.useEffect)(function () {
    if (!isActive && !isFirstRender) {
      if (onBlur) onBlur();
    }
  }, [isActive]);
  var selectText = valueText || placeholder;
  var placeholderClass = valueText ? '' : 'placeholder';
  var showClass = isActive && !disabled ? 'show' : '';
  var disabledClass = disabled ? 'disabled' : '';
  return /*#__PURE__*/_react["default"].createElement(_index.Space, _extends({
    size: "small",
    direction: "vertical",
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "small",
    justify: "space-between",
    className: "k-ds-width-full",
    direction: "horizontal"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "k-ds-body-01 k-ds-text-color-primary",
    htmlFor: name
  }, label, required ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-text-color-error"
  }, ' *') : null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-label-01 k-ds-text-color-interactive-secondary"
  }, optional)), /*#__PURE__*/_react["default"].createElement(StyledSelectOutline, {
    className: "k-ds-width-full k-ds-body-01",
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "medium",
    justify: "space-between",
    className: "k-ds-width-full selected ".concat(placeholderClass, " ").concat(disabledClass),
    onClick: onSelectClick,
    direction: "horizontal",
    align: "center",
    "aria-hidden": true
  }, /*#__PURE__*/_react["default"].createElement("span", null, selectText), /*#__PURE__*/_react["default"].createElement(IconArrowDown, {
    className: "".concat(showClass)
  })), selectOptions.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "options-group ".concat(showClass)
  }, optionsData.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.id,
      className: "option"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      id: option.id,
      name: name,
      value: option.value,
      form: form,
      defaultChecked: option.isSelected
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: option.id,
      onClick: function onClick() {
        return onOptionClick(option.value);
      },
      "aria-hidden": "true"
    }, option.text));
  })) : null, helper || hasError ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "helper-error k-ds-caption-01"
  }, errorMessage || helper) : null));
};